import React, { useState, useRef } from 'react';
import Slider from '../../components/AudioPlayer/Slider';
import { PlayButton, Volume, Mute } from '../../components/AudioPlayer/Controls';
import { func } from 'prop-types';

const DEFAULT_VOLUME = 30;

export default function useAudioPlayer(audioMeta, isPrimaryLight, index, setPlayerIndex) {
  const [isPlaying, setIsPlaying] = useState(false);
  const [volume, setVolume] = useState(DEFAULT_VOLUME);
  const [prevVolume, setPrevVolume] = useState(DEFAULT_VOLUME);

  const audioRef = useRef();

  const handlePlay = () => {
    const audio = audioRef.current;

    if (!isPlaying) {
      setIsPlaying(true);
      audio.volume = volume / 100;
      audio.play();
      setPlayerIndex && setPlayerIndex(index);
    } else {
      setIsPlaying(false);
      audio.pause();
    }
  };

  const handleHasEnded = () => {
    setIsPlaying(false);
  };

  const resetPlayer = () => {
    const audio = audioRef.current;
    setIsPlaying(false);
    audio.pause();
    audio.currentTime = 0;
  };

  const handleVolumeChange = val => {
    const audio = audioRef.current;
    audio.volume = val / 100;
    setVolume(val);
    setPrevVolume(val);
  };

  const handleToggleMute = () => {
    const audio = audioRef.current;
    const updateVolume = audio.volume === 0 ? prevVolume : 0;
    audio.volume = updateVolume / 100;
    setVolume(updateVolume);
  };

  return {
    playButton: (
      <PlayButton play={ handlePlay } isPlaying={ isPlaying } isPrimaryLight={ isPrimaryLight } />
    ),
    progress: <Slider ref={ audioRef } audioMeta={ audioMeta } onHasEnded={ handleHasEnded } />,
    volume: <Volume handleVolumeChange={ handleVolumeChange } volume={ volume } />,
    mute: <Mute handleToggleMute={ handleToggleMute } volume={ volume } />,
    play: handlePlay,
    reset: resetPlayer
  };
}

PlayButton.propTypes = {
  handleShouldPlay: func
};
